<template>
  <div class="alert alert-danger">
    Nie posiadasz uprawnień do wyświetlenia tego modułu
  </div>
</template>

<script>
export default {
  name: "NoAccess",
};
</script>

<style></style>
